// src/components/EquipmentRental.js
import React, { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import Beams from './Beams';  // Assuming you have this component
import '../styles/Equipmentrental.css';

import smallImage from '../assets/er-bg4.png';
import Rental from './Rental';
import AOS from "aos"; // Import AOS
import "aos/dist/aos.css"; // Import AOS styles

const EquipmentRental = () => {
  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 1000, // Animation duration
      once: false, // Whether animation should happen only once - while scrolling down
    });
    window.scrollTo(0, 0); // Scroll to top
  }, []); // Empty dependency array ensures this runs once on mount

  return (
    <>
      <Header />

      <div className="equipmentrental-container">
        {/* Beams Background */}
        <div className="equipmentrental-beam-background">
          <Beams
            beamWidth={2}
            beamHeight={30}
            beamNumber={14}
            lightColor="#00CCFF"
            speed={20}
            noiseIntensity={0}
            scale={0.19}
            rotation={59}
          />
        </div>

        {/* Content Section */}
        <div className="equipmentrental-left" data-aos="fade-right">
          <h1>Equipment Rental</h1>
          <p>
            We offer a wide range of well maintained and quickly transportable electrical testing equipment from Omicron, Doble, Fluke, Megger, and Scope with valid calibration certificate.<br /><br />
            Our on-time delivery of equipment ensured to meet the testing requirements that are scheduled at project sites. Our equipment rental division focused from feasibility to successfulness of client requirement in terms of equipment make, available accessories, application software and method of statements cohesively. We provide qualified testing engineer under the request of client with rented equipment. Our testing engineer conducts testing activities with detailed report of analysis through safe and proper operation of the equipment.<br /><br />
            We offer transportation for delivery & collection of equipment all over UAE. For overnight and immediate requirements can be fulfilled with the support of client's logistics arrangement.
          </p>
        </div>

        <div className="equipmentrental-right" data-aos="fade-left">
          <img src={smallImage} alt="Equipment Rental" />
        </div>

        {/* Additional Info with PDF Download */}
        <div className="equipmentrental-download" data-aos="fade-up">
          <h2>Download Rental Equipment Brochure</h2>
          <p>
            For a detailed list of available testing equipment, specifications, and rental terms, you can download our brochure using the link below.
          </p>
     <a href="/pdfs/equipment-brochure.pdf" download className="download-link">
  <i className="fas fa-file-pdf"></i> Download PDF Brochure
</a>
        </div>
      </div>

      <Rental />
      <Footer />
    </>
  );
};

export default EquipmentRental;
